/* eslint-disable import/no-anonymous-default-export */
import { SCANNER_DATA, JOB_DATA, CLEAR_JOB_DATA } from "./type";

const initialState = {
    scannerDataList: {},
    jobDataList: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SCANNER_DATA:
            return {
                ...state,
                scannerDataList: { ...state.scannerDataList, ...action.payload }
            }

        case JOB_DATA:
            return {
                ...state,
                jobDataList: { ...state.jobDataList, ...action.payload }
            }

        case CLEAR_JOB_DATA:
            return {
                ...state,
                jobDataList: {}
            }
        default:
            return { ...state };
    }
};
